import type { TefComsCancelButton } from '@mfe/components/TefComsCancelButton';
import { componentStateStore } from '@mfe/store';
import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';

// a cancel button that triggers an event
export const tefComsCancelButton = function render(this: TefComsCancelButton) : ReturnType<typeof html> {
  const classes = {
    button: true, 'button-default--prio-tertiary': true, 'button-tag--state-disabled': componentStateStore.disabled,
  };

  return html`
    <button class=${classMap(classes)} @click="${this.handleClick}" ?disabled=${componentStateStore.disabled}>
       <tef-icon icon="chevron-left"></tef-icon>
       ${this.text}
    </button>
  `;
};
